import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styled, { css } from 'styled-components';
import { BaseBox, Body1, FlexBox, PrimaryButton, Heading3 } from '@docon/docon-ui-library';
import Layout, { MainBody } from '../Layout';
import Image from 'shared/Image';
import { downloadAppPromotion } from 'shared/DownloadApp';
import { colors } from 'utilities/colorConfig';

const HomeIcon = '/images/homeicon.svg';
const chatImage = '/images/chatImage.svg';
const chatIcon2 = '/images/chatTextIcon2.svg';
const chatIcon3 = '/images/chatTextIcon3.svg';

const Title = styled(Heading3)`
  padding: 12px 0;
  font-weight: 700;
  border-bottom: 1px solid ${colors.white};
`;

const Content = styled(BaseBox)`
  margin: 0 14px 10px;
  padding: 0px 20px;
  border-radius: 10px;
  background-color: ${colors.blueColor[4]};

  ${FlexBox} {
    padding: 8px 0;
    align-items: center;
    text-align: left;
  }

  ${Body1} {
    flex: 1;
    color: currentColor;
  }
`;

const Root = styled(Layout)`
  text-align: center;

  ${MainBody} {
    padding: 5%;
    display: flex;
    flex-direction: column;
  }

  ${PrimaryButton} {
    margin: 0;
    margin-top: auto;
  }

  ${() => isMobileOnly && css`
    ${Content} {
      margin: 0px 5%;
    }
  `}
`;

export default function ChatComponent() {

  return (
    <Root>
      <Image
        src={chatImage}
        alt=''
        m='auto'
        height='196px'
      />

      <Content>
        <Title title='Chat with your doctor for FREE' />
        <FlexBox>
          <Image src={HomeIcon} alt='' />
          <Body1 title='Ask queries related to your past consultations with the doctor' />
        </FlexBox>
        <FlexBox>
          <Image src={chatIcon2} alt='' />
          <Body1>
            <span style={{ fontWeight: 'bold' }} >100% Private & Secure</span>
            <span> Communication</span>
          </Body1>
        </FlexBox>
        <FlexBox>
          <Image src={chatIcon3} alt='' />
          <Body1>
            <span style={{ fontWeight: 'bold' }}>FREE</span>
            <span> feature only on Docon</span>
          </Body1>
        </FlexBox>
      </Content>
      <PrimaryButton
        isBlock
        title='Get App'
        size='small'
        onClick={downloadAppPromotion}
      />
    </Root>
  );
}